import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/starlight-logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["GamesMoreGamesLink"] */ "/vercel/path0/apps/web/src/app/games/_components/games-more-games-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_@babel+core@7.24.5_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_@babel+core@7.24.5_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
